<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
    {{ item }} -->
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.name }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header>
      <b-card-body class="py-0">
        <div>
          <b-row>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label-cols="12"
                label="Client SL A/C"
                label-size="sm"
              >
                <treeselect
                  placeholder="Select slac..."
                  searchPromptText="Type at least 3 chars..."
                  v-model="item.id"
                  :clearable="true"
                  :async="true"
                  :load-options="treeselect_loadSLAC"
                  :show-count="true"
                  :flatten-search-results="true"
                  :disable-branch-nodes="true"
                  :matchKeys="['id']"
                  search-nested
                  :disabled="false"
                >
                  <div slot="value-label" slot-scope="{ node }">
                    {{ node.raw.id }}
                  </div>
                </treeselect>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Zone_U" label-for="zoneu" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.zoneu"
                    placeholder="Enter Zone_U"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.zoneu = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Zone_E" label-for="zonee" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.zonee"
                    placeholder="Enter Zone_E"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.zonee = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Zone_L" label-for="zonel" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.zonel"
                    placeholder="Enter Zone_L"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.zonel = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="UserPCC" label-for="userpcc" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.userpcc"
                    placeholder="Enter UserPCC"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.userpcc = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="GenZone_U"
                label-for="genzoneu"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.genzoneu"
                    placeholder="Enter GenZone_U"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.genzoneu = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="GenZone_E"
                label-for="genzonee"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.genzonee"
                    placeholder="Enter GenZone_E"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.genzonee = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="GenZone_L"
                label-for="genzonel"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.genzonel"
                    placeholder="Enter GenZone_L"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.genzonel = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="NonGenZone_U"
                label-for="nongenzoneu"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.nongenzoneu"
                    placeholder="Enter NonGenZone_U"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.nongenzoneu = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="NonGenZone_E"
                label-for="nongenzonee"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.nongenzonee"
                    placeholder="Enter NonGenZone_E"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.nongenzonee = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="NonGenZone_L"
                label-for="nongenzonel"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.nongenzonel"
                    placeholder="Enter NonGenZone_L"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.nongenzonel = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Group" label-for="group" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.group"
                    placeholder="Enter Group"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.group = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="LCC_Charge"
                label-for="lcccharge"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.lcccharge"
                    placeholder="Enter LCC_Charge"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.lcccharge = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="idselected">
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Created At"
                label-for="created_at"
                label-cols="12"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-datepicker
                      size="sm"
                      v-model="item.created_at"
                      button-only
                      label-help=""
                      locale="en-GB"
                      :disabled="true"
                    ></b-form-datepicker>
                  </b-input-group-prepend>
                  <b-form-input
                    size="sm"
                    id="date"
                    v-model="item.created_at"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.created_at = null"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Created By"
                label-for="created_by"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.created_by"
                    placeholder=""
                    size="sm"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.created_by = ''"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Updated At"
                label-for="updated_at"
                label-cols="12"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-datepicker
                      size="sm"
                      v-model="item.updated_at"
                      button-only
                      label-help=""
                      locale="en-GB"
                      :disabled="true"
                    ></b-form-datepicker>
                  </b-input-group-prepend>
                  <b-form-input
                    size="sm"
                    id="date"
                    v-model="item.updated_at"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.updated_at = null"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Updated By"
                label-for="updated_by"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.updated_by"
                    placeholder=""
                    size="sm"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.updated_by = ''"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
            <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button squared size="sm" variant="primary" @click="saveit">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "ZoneCharges",

  data() {
    return {
      busy: false,

      item: {
        id: null,
        zoneu: null,
        zonee: null,
        zonel: null,
        userpcc: null,
        genzoneu: null,
        genzonee: null,
        genzonel: null,
        nongenzoneu: null,
        nongenzonee: null,
        nongenzonel: null,
        group: null,
        lcccharge: null,
      },
      options: {
        title: "Zone Charges",
        icon: "fa fa-building",
      },
    };
  },
  methods: {
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query zonecharges($id: String) {
              zonecharges(id: $id) {
                id
                slac
                zoneu
                zonee
                zonel
                userpcc
                genzoneu
                genzonee
                genzonel
                nongenzoneu
                nongenzonee
                nongenzonel
                group
                lcccharge
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.zonecharges.length > 0) {
          this.item = response.data.zonecharges[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let variables = { rows: [this.cleanit(this.item)] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation savezonecharges(
              $rows: [Zonecharges_input]
              $dateformat: String
            ) {
              savezonecharges(rows: $rows, dateformat: $dateformat) {
                id
                slac
                zoneu
                zonee
                zonel
                userpcc
                genzoneu
                genzonee
                genzonel
                nongenzoneu
                nongenzonee
                nongenzonel
                group
                lcccharge
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style>
</style>